'use strict';

import FieldView from 'views/record/Field';

class NumberField extends FieldView{
}

export default NumberField;
